var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-headful',{attrs:{"title":"Parent Signup | Gradelyng","description":"Description goes here"}}),_c('AuthContainer',[_c('div',{attrs:{"slot":"auth_form_block"},slot:"auth_form_block"},[_c('SignupForm')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }